import { z } from 'zod';

import { openingHoursSchema } from './businessInfo';

/**
 * Working days + opening hours, collected on the review ("almost done") step.
 * Notes live on the representative step; the logo is handled by the uploader.
 */
export const hoursScheduleSchema = z.object({
  workingDays: z.array(z.string()).min(1, 'required'),
  openingHours: openingHoursSchema,
});

export const finalDetailsSchema = z.object({
  openingHours: openingHoursSchema,
});

export type FinalDetailsInput = z.infer<typeof finalDetailsSchema>;
